import React, { useEffect } from "react";
import { Route, Switch, HashRouter, Redirect } from "react-router-dom";
import { locale, loadMessages } from "devextreme/localization";
import { Provider } from "react-redux";
import store from "./common/redux/store";
import "./App.scss";
import PrivateRoute from "./common/components/PrivateRoute";
import gbDxMessages from "./common/lang/devExtreme/gb.js";
import plDxMessages from "./common/lang/devExtreme/pl.js";
import Logger from "./../src/common/utils/Logger/Logger";
import "./Themes/themes";
import { QueryClient, QueryClientProvider } from "react-query";

import NotFoundScreen from "./common/screens/NotFoundScreen";
import SignOutScreen from "./common/screens/SignOutScreen";
import ContactScreen from "./Screens/ContactScreen";
import routes from "./routes";
import LayoutWithSideMenu from "./common/components/LayoutWithSideMenu";

window.store = store;
window.log = Logger;
window.log.LoadConfig();

export const groupButtonIsVisible = false;

const queryClient = new QueryClient();

const App = (props) => {
    useEffect(() => {
        loadMessages(gbDxMessages);
        loadMessages(plDxMessages);
        locale(
            !!window.store.getState().authReducer
                ? window.store.getState().authReducer.lang
                : "gb"
        );
    });

    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={window.store}>
                <HashRouter>
                    <LayoutWithSideMenu>
                        <Switch>
                            <PrivateRoute exact path="/">
                                <Redirect exact from="/" to="agreement" />
                            </PrivateRoute>
                            <Route exact path="/signout" component={SignOutScreen} />
                            {routes.map(({ path, name, Component }, key) => (
                                <PrivateRoute
                                    exact
                                    path={path}
                                    key={key}
                                    render={(props) => {
                                        return <Component {...props} />;
                                    }}
                                />
                            ))}
                            <Route exact path={"/contact"} component={ContactScreen} />
                            <Route component={NotFoundScreen} />
                        </Switch>
                    </LayoutWithSideMenu>
                </HashRouter>
            </Provider>
        </QueryClientProvider>
    );
};

export default App;
